<template>
    <section>
        <div class="row14">
            <swiper class="swiper" ref="swiper" :options="teacherSwiperOption">
                <swiper-slide v-for="(item, index) in list" :key="index">
                    <div class="view_58" @click="goTeacherDetail(item)" @mouseover="showDetails">
                        <div class="view_57">
                            <img
                                v-if="item.headerImageUrl"
                                class="avator_2"
                                :src="item.headerImageUrl"
                            />
                            <img class="avator_2" v-else :src="imgPath.teacher_head" />  
                            <div class="color_14" />
                        </div>
                        <div class="block_158">
                            <div class="block_156"><div class="color_15" /></div>
                            <!-- <div class="block_157">
                              <img
                                      class="icon_255"
                                      src="../images/img_32389_0_278.png"
                              />
                            </div> -->
                        </div>
                        <div class="color_16" />
                        <span class="text_36" :lines="1">{{item.name}}</span>
                        <div class="block_159">
                            <img
                                    class="icon_256"
                                    src="../images/img_32389_0_272.png"
                            />
                            <img
                                    class="icon_257"
                                    src="../images/img_32389_0_273.png"
                            />
                            <img
                                    class="icon_258"
                                    src="../images/img_32389_0_274.png"
                            />
                            <img
                                    class="icon_259"
                                    src="../images/img_32389_0_275.png"
                            />
                            <img
                                    class="icon_260"
                                    src="../images/img_32389_0_276.png"
                            />
                        </div>
                        <div class="mask">
                            <div class="mask-content">
                                <p class="mask-title">{{item.name}}</p>
                                <p class="mask-introduce">{{item.introduce}}</p>                                  
                            </div>
                        </div>
                    </div>
                    
                </swiper-slide>                
                <!-- <div class="swiper-button-prev" slot="button-prev">
                    <div class="block_150">
                        <img 
                                class="icon_244"
                                src="../images/img_32389_0_279.png"
                        />
                    </div>
                </div>
                <div class="swiper-button-next" slot="button-next">
                    <div class="block_157">
                        <img
                                class="icon_255"
                                src="../images/img_32389_0_278.png"
                        />
                    </div>
                </div> -->
            </swiper>
        </div>
    </section>
</template>

<script>
    import imgPath from "@/common/img-path";
    import {teacherRecommendList} from "@/servers/api"
    export default {
        name: "teacherBlock",
        data(){
            return{
                imgPath: imgPath,
                teacherSwiperOption: { // 名师专区
                    slidesPerView: 4,
                    spaceBetween: 20,
                    direction: 'horizontal',
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    },
                    on: {
                        resize: () => {
                            this.$refs.swiper.$swiper.changeDirection(
                                window.innerWidth <= 960
                                    ? 'vertical'
                                    : 'horizontal'
                            )
                        }
                    }
                },
                list: []
            }
        },
        created() {
            const params = {
                currentPage: 1,
                pageSize: 10
            }
            // this.teacherRecommendList(params)
        },
        methods:{
            async teacherRecommendList(params) {
                const res = await teacherRecommendList(params);
                if (res.code == 0) {
                    this.list = res.data
                    console.log('list', this.list)
                }
            },
            goTeacherDetail (item) {
                this.$router.push({
                    path: '/teacher/detail',
                    query: { id: item.teacherId }
                });                
            },
            showDetails() {}
        },
        
    }
</script>

<style src="../index.css" scoped >
</style>
<style lang="less" scoped>
    .row14 .swiper-button-prev:after, .swiper-container-rtl .swiper-button-next:after,
    .row14 .swiper-button-next:after, .swiper-container-rtl .swiper-button-prev:after{
        content: none!important;
    }
    .row14 .swiper-button-next{
        opacity: 1 !important;
        right: 1px;
    }
    .row14 .swiper-button-prev{
        opacity: 1 !important;
        left: 1px;
    }
    .avator_2 {
        border-radius: 50%;
    }
    .view_58 {
        cursor: pointer;
    }
    .view_58:hover .mask {
        display: block;
    }
    .mask {
        position: absolute;
        display: none;
        width: 280px;
        height: 100%;
        color: #FFFFFF;
        font-size: 14px;
        padding-top: 30px;
        /* padding-right: 20px; */
        word-wrap: break-word;
        word-break: break-all;
        background: rgba(0, 0, 0, .5);
        overflow:auto;
        .mask-title {
            font-size: 20px;
            text-align: center;
            color: #fff;
        }
        .mask-introduce {
            font-size: 15px;
            color: #fff;
            margin-top: 15px;
            overflow : hidden;
            text-overflow: ellipsis;
            /* 将对象作为弹性伸缩盒子模型显示  */
            display: -webkit-box;
            /* 一个块元素显示的文本的行数 */
            -webkit-line-clamp: 8;
            /* 设置或检索伸缩盒对象的子元素的排列方式 */
            -webkit-box-orient: vertical;
        }
    }
    .mask .mask-content {
        padding: 20px;
    }    
</style>
